import Vue from 'vue'
import Vuex from 'vuex'
import authStore from './modules/auth'
import globalStore from './modules/global'
import flightStore from './modules/flight'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    authStore,
    globalStore,
    flightStore,
  }
})